import { get } from 'lodash'

export const DATA_VERSION = {
  SELECTED: 0,
  LATEST: 99999
}

export const isUpdatedData = (sourceDataList, compareData) => {
  // ? this problem is SQL is save DATE as String but dynamoDB is keep DATE as Unix
  const sourceData = sourceDataList.find(item => Number(item.id) === Number(compareData.id))
  let sourceDataUpdatedAt = get(sourceData, 'updatedAt', 0)

  if (typeof sourceDataUpdatedAt === 'string') {
    sourceDataUpdatedAt = Math.floor(new Date(sourceDataUpdatedAt).getTime() / 1000)
  }

  if (sourceDataUpdatedAt > compareData.updatedAt) {
    return true
  }
  return false
}

export const isDeletedData = (sourceDataList, searchId) => {
  const sourceData = sourceDataList.find(item => Number(item.id) === Number(searchId))

  if (sourceData === undefined) {
    return true
  }

  return false
}

export const getDataCheckList = (sourceDataList, currentSelectedDataList, defaultVal = false) => {
  const dataCheckedList = sourceDataList.map((sourceData, index) => {
    const contractDataChecked = currentSelectedDataList.find(item => Number(item.id) === Number(sourceData.id))
    const data = {
      id: sourceData.id,
      index: index,
      isCheck: defaultVal,
      version: DATA_VERSION.SELECTED
    }

    if (contractDataChecked === undefined) {
      data.isCheck = false
      return data
    }
    data.isCheck = true

    return data
  })
  return dataCheckedList
}

export const getSelectedDataListByVersion = (dataCheckList, currentSelectedDataList, sourceDataList) => {
  const checkedList = dataCheckList.filter(item => item.isCheck === true)
  const resultList = _getResultByVersion(checkedList, currentSelectedDataList, sourceDataList)

  return resultList
}

function _getResultByVersion (checkedList, objectDataList, sourceDataList) {
  const resultList = checkedList.map((checkedData) => {
    if (checkedData.version === DATA_VERSION.SELECTED) {
      return objectDataList[checkedData.index]
    }

    const sourceData = sourceDataList.find(item => item.id === checkedData.id)
    return sourceData
  })

  return resultList
}

// function _convertStringDateTimeToUnix (StringDate) {
//   let date = new Date(`${StringDate}`.split(' ').join('T'))
//   return date.getTime() / 1000
//
// }
